module.exports = __webpack_public_path__ + "img/ca_lang.2d892227.png";